export const enum TeamDetailLevel {
  Basic = "BASIC",
  Full = "FULL",
   
  }